'use strict';

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _store = require('./config/store');

var _store2 = _interopRequireDefault(_store);

var _reactRouter = require('react-router');

var _sync = require('react-router-redux/lib/sync');

var _sync2 = _interopRequireDefault(_sync);

var _router = require('./router/router');

var _router2 = _interopRequireDefault(_router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var store = (0, _store2.default)();
var appHistory = (0, _sync2.default)(_reactRouter.browserHistory, store);

_reactDom2.default.render(_react2.default.createElement(
    _reactRedux.Provider,
    { store: store },
    _react2.default.createElement(
        'div',
        { id: 'index-page-box' },
        _react2.default.createElement(_reactRouter.Router, { history: appHistory, routes: (0, _router2.default)() })
    )
), document.getElementById('root'));


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 193
// module chunks = 0